exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-0522255d] {\n  font-size: .8em;\n}\n", ""]);

// exports
